export const PHONE_COUNTRY_INPUT_PROPS = Object.freeze({
  clearable: false,
  hideDetails: true,
  menuProps: {
    contentClass: 'v-autocomplete__content custom-dropdown v-phone-input__country__menu'
  }
})
